module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/thigh-9557cab4f93a9143dddfac5fdf60cd6f.png";